import { render, staticRenderFns } from "./aShopDetailRefundGOrders.vue?vue&type=template&id=72816086&scoped=true"
import script from "./aShopDetailRefundGOrders.vue?vue&type=script&lang=js"
export * from "./aShopDetailRefundGOrders.vue?vue&type=script&lang=js"
import style0 from "./aShopDetailRefundGOrders.vue?vue&type=style&index=0&id=72816086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72816086",
  null
  
)

export default component.exports